import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  FilePreviewDialogComponent,
  IFilePreviewDialogData
} from './file-preview-dialog.component';

/**
 * Opens a full-screen, high-performance File Preview Dialog for any document in the CRM.
 *
 * @param dialog The Angular MatDialog service instance.
 * @param data Target file preview metadata (URL, fileName, size, category).
 * @returns MatDialogRef instance for the opened modal.
 */
export function openFilePreviewDialog(
  dialog: MatDialog,
  data: IFilePreviewDialogData
): MatDialogRef<FilePreviewDialogComponent> {
  return dialog.open(FilePreviewDialogComponent, {
    data,
    width: '96vw',
    maxWidth: '96vw',
    height: '94vh',
    maxHeight: '94vh',
    panelClass: 'file-preview-dialog-panel',
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-dark-backdrop',
    autoFocus: false,
    disableClose: false
  });
}
